module.exports = __webpack_public_path__ + "6e6757bcfaa134fff1c2ef3120cf03ae.png";